import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AngularSvgIconModule } from "angular-svg-icon";
import { initialize as createLaunchDarklyClient } from "launchdarkly-js-client-sdk";
import * as mixpanel from "mixpanel-browser";
import { FeatureService, featureServiceInjectionToken, launchDarklyInitializer, mooGlobalInjectionToken } from "moo-shared";
import { ThumbnailModule } from "moo-shared/ui";
import { CoreCommonModule } from "moo-vuexy-core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthenticationCoreModule } from "./core/core.module";
import { GroupDetailsComponent } from "./features/login-assistant/group-list/group-details/group-details.component";
import { GroupListComponent } from "./features/login-assistant/group-list/group-list.component";
import { LoginAssistantComponent } from "./features/login-assistant/login-assistant.component";
import { LoginAssistantService } from "./features/login-assistant/login-assistant.service";
import { OrganisationListComponent } from "./features/login-assistant/organisation-list/organisation-list.component";
import { TileComponent } from "./features/login-assistant/tile/tile.component";
import { LoginComponent } from "./features/login/login.component";
import { LoginService } from "./features/login/login.service";
import { PasswordLoginComponent } from "./features/login/password-login/password-login.component";
import { ChromeDeviceService } from "./features/login/picture-login/chrome-device-service";
import { PictureLoginComponent } from "./features/login/picture-login/picture-login.component";
import { PictureSelectionComponent } from "./features/login/picture-login/picture-selection.component";
import { QrLoginComponent } from "./features/login/qr-login/qr-login.component";
import { PasswordUpdateComponent } from "./features/password-update/password-update.component";
import { PasswordUpdateService } from "./features/password-update/password-update.service";
import { PasswordInputComponent } from "./shared/FormControls/password-input/password-input.component";
import { NotificationBarModule } from "./shared/notification-bar/notification-bar.module";
import { ThumbnailImageComponent } from "./shared/protected-image-thumbnail/protected-image-thumbnail.component";
import { ExtraValidationComponent } from "./features/password-update/extra-validation/extra-validation.component";
import {ModalComponent} from "cool-shared/overlay";
import {MessageComponent} from "cool-shared/display";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PictureLoginComponent,
    PictureSelectionComponent,
    PasswordLoginComponent,
    PasswordInputComponent,
    LoginAssistantComponent,
    GroupDetailsComponent,
    GroupListComponent,
    OrganisationListComponent,
    ThumbnailImageComponent,
    PasswordUpdateComponent,
    TileComponent,
    QrLoginComponent,
    ExtraValidationComponent
  ],
  imports: [
    AuthenticationCoreModule,
    BrowserModule,
    AppRoutingModule,
    CoreCommonModule,
    NotificationBarModule,
    ThumbnailModule,
    AngularSvgIconModule.forRoot(),
    ModalComponent,
    MessageComponent
  ],
  providers: [LoginService, LoginAssistantService, PasswordUpdateService, ChromeDeviceService,
    { provide: mooGlobalInjectionToken, useFactory: () => window.moo },
    { provide: featureServiceInjectionToken, useClass: FeatureService },
    launchDarklyInitializer(createLaunchDarklyClient),
    { provide: "Mixpanel", useValue: mixpanel },
    { provide: "ProjectToken", useValue: "f84461ef1c7292e73b27b46cbf15aed3" }],
  bootstrap: [AppComponent]
})
export class AppModule {
}

